import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=06e58d0e&scoped=true&"
import script from "./Teachers.vue?vue&type=script&lang=js&"
export * from "./Teachers.vue?vue&type=script&lang=js&"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=06e58d0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e58d0e",
  null
  
)

export default component.exports